export default __webpack_public_path__ + "static/commmune_sns_and_communitysite-be421088afaaa39efea80a0a8862e2d4.png";